import { useSize } from '../../hooks/useSize';
import { FRAME_WIDTH, ROW_LIMIT, SEAT_WIDTH, MOBILE_WIDTH, SEAT_SMALLWIDTH, NORMAL_WIDTH, Scales } from './constants';
import { seatHalfScaleStyle, seatScaleStyle } from './useStyles';

export const usePassengerGridView = (rowLength, isMobile) => {
    const { width } = useSize();
    const gridWidth = width - FRAME_WIDTH;
    const maxWidth = rowLength > ROW_LIMIT ? SEAT_WIDTH * rowLength : MOBILE_WIDTH;
    const maxWidthMobile = rowLength > ROW_LIMIT ? SEAT_SMALLWIDTH * rowLength : MOBILE_WIDTH;
    const joinAisleOffset = gridWidth >= NORMAL_WIDTH ? (gridWidth - NORMAL_WIDTH) / 10 : 0;
    const scale =
        (rowLength > ROW_LIMIT && gridWidth <= SEAT_SMALLWIDTH * Scales.MEDIUM * rowLength && Scales.SMALL) ||
        ((isMobile || gridWidth <= maxWidthMobile) && Scales.MEDIUM);
    const seatStyle = { ...((scale === Scales.MEDIUM && { ...seatScaleStyle }) || (scale === Scales.SMALL && { ...seatHalfScaleStyle })) };

    return {
        gridWidth,
        maxWidth,
        joinAisleOffset,
        seatStyle,
    };
};
